import { Type } from "@sinclair/typebox";
import { ResultDocumentSchema } from "./result-document.js";
import { IdSchema, Sha256Schema, TimestampSchema } from "./shared.js";
import { SessionFilePathSchema } from "./files.js";
export const DemoIdSchema = Type.String({ pattern: "^[a-z][a-z0-9-]{0,63}$" });
const text = Type.String({ minLength: 1, maxLength: 32_000 });
export const DemoSourceSchema = Type.Object({ caseId: DemoIdSchema, caseDigest: Sha256Schema }, { additionalProperties: false });
export const DemoAssetSchema = Type.Object({
    assetId: DemoIdSchema,
    name: Type.String({ pattern: "^[A-Za-z0-9][A-Za-z0-9_.-]{0,127}$" }),
    path: SessionFilePathSchema,
    digest: Sha256Schema,
    sizeBytes: Type.Integer({ minimum: 0, maximum: 512 * 1024 * 1024 }),
    mediaType: Type.Union([
        Type.Literal("application/octet-stream"),
        Type.Literal("application/json"),
        Type.Literal("text/plain"),
        Type.Literal("text/csv"),
        Type.Literal("text/html"),
        Type.Literal("image/png"),
        Type.Literal("image/jpeg"),
    ]),
}, { additionalProperties: false });
export const DemoStageIds = ["input", "folding", "complex", "interface", "report"];
export const DemoStageSchema = Type.Object({
    stageId: Type.Union(DemoStageIds.map((id) => Type.Literal(id))),
    title: Type.String({ minLength: 1, maxLength: 200 }),
    explanation: text,
    document: ResultDocumentSchema,
}, { additionalProperties: false });
export const DemoCaseSchema = Type.Object({
    schemaVersion: Type.Literal("1.0.0"),
    caseId: DemoIdSchema,
    title: Type.String({ minLength: 1, maxLength: 300 }),
    goal: text,
    hypotheses: Type.Array(text, { minItems: 1, maxItems: 8 }),
    plan: Type.Array(text, { minItems: 1, maxItems: 16 }),
    groups: Type.Array(Type.Object({
        groupId: DemoIdSchema,
        label: text,
        sequence: Type.String({ pattern: "^[ACGU]+$", maxLength: 1000 }),
        changes: text,
    }, { additionalProperties: false }), { minItems: 4, maxItems: 4 }),
    stages: Type.Array(DemoStageSchema, { minItems: 5, maxItems: 5 }),
    summary: text,
    dialogue: Type.Array(Type.Object({
        role: Type.Union([Type.Literal("user"), Type.Literal("assistant")]),
        content: text,
    }, { additionalProperties: false }), { minItems: 2, maxItems: 64 }),
    followUpQuestions: Type.Array(text, { minItems: 1, maxItems: 6 }),
    assets: Type.Array(DemoAssetSchema, { minItems: 1, maxItems: 256 }),
    continuation: Type.Object({
        assetIds: Type.Array(DemoIdSchema, { minItems: 1, maxItems: 31, uniqueItems: true }),
        archive: Type.Optional(Type.Object({
            assetId: DemoIdSchema,
            members: Type.Array(Type.Object({
                assetId: DemoIdSchema,
                memberName: Type.String({
                    pattern: "^[a-z][a-z0-9-]{0,63}/[A-Za-z0-9][A-Za-z0-9_.-]{0,127}$",
                }),
            }, { additionalProperties: false }), { minItems: 1, maxItems: 256 }),
        }, { additionalProperties: false })),
    }, { additionalProperties: false }),
    sources: Type.Array(Type.Object({ title: text, url: Type.String({ pattern: "^https://[^\\s]+$", maxLength: 2048 }) }, { additionalProperties: false }), { minItems: 1, maxItems: 32 }),
    provenance: Type.Object({
        executionKind: Type.Literal("real"),
        computedAt: TimestampSchema,
        evidenceDigest: Sha256Schema,
    }, { additionalProperties: false }),
}, { additionalProperties: false });
export const DemoCaseResponseSchema = Type.Object({ caseDigest: Sha256Schema, case: DemoCaseSchema }, { additionalProperties: false });
export const ContinueDemoBodySchema = Type.Object({
    requestId: IdSchema,
    caseDigest: Sha256Schema,
    seriesId: Type.String({ pattern: "^[a-z][a-z0-9_-]{0,63}$" }),
}, { additionalProperties: false });
//# sourceMappingURL=demo.js.map